import { Yield } from '../../abacus/interfaces/yield.interface'

export const coreApplicationAreaYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
